(function () {
  var root = document.getElementById('media-gallery-root');
  var enableNavigation = root && root.dataset.enableNavigation === 'true';

  function initMediaGalleryProductVideos() {
    if (!root) return;
    root.querySelectorAll('.media-gallery-video-wrap').forEach(function (wrap) {
      if (wrap.dataset.galleryVideoBound === 'true') return;
      var video = wrap.querySelector('video.media-gallery__video-el') || wrap.querySelector('video');
      if (!video) return;
      wrap.dataset.galleryVideoBound = 'true';
      video.setAttribute('playsinline', '');
      var btnPlay = wrap.querySelector('.media-gallery-video-play');
      var btnMute = wrap.querySelector('.media-gallery-video-mute');
      if (!btnPlay || !btnMute) return;
      var iconPause = btnPlay.querySelector('.media-gallery-video-play__icon-pause');
      var iconPlay = btnPlay.querySelector('.media-gallery-video-play__icon-play');
      var iconMuted = btnMute.querySelector('.media-gallery-video-mute__icon-muted');
      var iconUnmuted = btnMute.querySelector('.media-gallery-video-mute__icon-unmuted');

      function syncPlayUi() {
        var playing = !video.paused;
        btnPlay.setAttribute('data-playing', playing ? 'true' : 'false');
        btnPlay.setAttribute('aria-pressed', playing ? 'true' : 'false');
        btnPlay.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
        if (iconPause && iconPlay) {
          iconPause.classList.toggle('hidden', !playing);
          iconPlay.classList.toggle('hidden', playing);
        }
      }
      function syncMuteUi() {
        var muted = video.muted;
        btnMute.setAttribute('data-muted', muted ? 'true' : 'false');
        btnMute.setAttribute('aria-pressed', muted ? 'true' : 'false');
        btnMute.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
        if (iconMuted && iconUnmuted) {
          iconMuted.classList.toggle('hidden', !muted);
          iconUnmuted.classList.toggle('hidden', muted);
        }
      }

      btnPlay.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        if (video.paused) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
      btnMute.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        video.muted = !video.muted;
      });
      video.addEventListener('play', syncPlayUi);
      video.addEventListener('pause', syncPlayUi);
      video.addEventListener('volumechange', syncMuteUi);
      syncPlayUi();
      syncMuteUi();
    });
  }

  initMediaGalleryProductVideos();

  function moveNode(node, newParent) {
    if (node && newParent && node.parentNode !== newParent) {
      newParent.appendChild(node);
    }
  }

  function waitForSwiper(cb) {
    if (window.Swiper) {
      cb();
    } else {
      setTimeout(function () {
        waitForSwiper(cb);
      }, 50);
    }
  }

  waitForSwiper(function () {
    var mainSwiper;
    var thumbsSwiper;
    var isModalOpen = false;
    var modal = document.getElementById('media-gallery-modal');
    var modalAnchor = document.getElementById('media-gallery-modal-swiper-anchor');
    var inlineAnchor = document.getElementById('media-gallery-swiper-inline');
    var mainSwiperEl = document.querySelector('.media-gallery-main');
    var thumbsSwiperEl = document.querySelector('.media-gallery-thumbs');

    function openModal(idx) {
      moveNode(mainSwiperEl, modalAnchor);
      if (thumbsSwiperEl) {
        moveNode(thumbsSwiperEl, modalAnchor);
        thumbsSwiperEl.style.display = '';
      }
      modal.classList.add('modal-open');
      document.body.classList.add('overflow-hidden');
      isModalOpen = true;
      mainSwiper.update();
      thumbsSwiper.update();
      if (mainSwiper.params.loop && typeof mainSwiper.slideToLoop === 'function') {
        mainSwiper.slideToLoop(idx, 0);
      } else {
        mainSwiper.slideTo(idx, 0);
      }
    }

    function closeModal() {
      moveNode(mainSwiperEl, inlineAnchor);
      if (thumbsSwiperEl) {
        moveNode(thumbsSwiperEl, inlineAnchor);
        thumbsSwiperEl.style.display = 'none';
      }
      modal.classList.remove('modal-open');
      document.body.classList.remove('overflow-hidden');
      isModalOpen = false;
      mainSwiper.update();
      thumbsSwiper.update();
    }

    document.querySelectorAll('.media-gallery-grid-item').forEach(function (el) {
      function openFromGrid() {
        var raw = el.getAttribute('data-gallery-index');
        var idx = raw != null ? parseInt(raw, 10) : NaN;
        if (!isNaN(idx)) openModal(idx);
      }
      el.addEventListener('click', openFromGrid);
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openFromGrid();
        }
      });
    });

    document
      .querySelectorAll('.media-gallery-main .swiper-slide img, .media-gallery-main .swiper-slide video')
      .forEach(function (el) {
        el.addEventListener('click', function () {
          var slide = el.closest('.swiper-slide');
          if (!slide) return;
          var raw = slide.getAttribute('data-gallery-index');
          var idx = raw != null ? parseInt(raw, 10) : NaN;
          if (!isNaN(idx)) openModal(idx);
        });
      });

    var closeBtn = document.getElementById('media-gallery-modal-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }

    modal.addEventListener('click', function (e) {
      if (!e.target.closest('img') && !e.target.closest('button')) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (isModalOpen && e.key === 'Escape') closeModal();
    });

    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') {
        var focusableEls = modal.querySelectorAll('button, [tabindex]:not([tabindex="-1"])');
        var firstEl = focusableEls[0];
        var lastEl = focusableEls[focusableEls.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === firstEl) {
            lastEl.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastEl) {
            firstEl.focus();
            e.preventDefault();
          }
        }
      }
    });

    function getCenteredSlides() {
      return window.innerWidth >= 990;
    }

    function initSwipers() {
      thumbsSwiper = new Swiper('.media-gallery-thumbs', {
        slidesPerView: 6,
        spaceBetween: 8,
        watchSlidesProgress: true,
        slideToClickedSlide: false,
        loop: true,
        momentum: true,
        on: {
          click: function (_swiper, event) {
            var slide = event.target.closest('.swiper-slide');
            if (slide && mainSwiper) {
              var idx = parseInt(slide.getAttribute('data-thumb-index'), 10);
              if (!isNaN(idx)) {
                mainSwiper.slideToLoop(idx);
                mainSwiper.update();
              }
            }
          },
        },
      });

      var mainOptions = {
        slidesPerView: 1.2,
        spaceBetween: 10,
        loop: true,
        centeredSlides: getCenteredSlides(),
        momentum: true,
        zoom: true,
        thumbs: {
          swiper: thumbsSwiper,
        },
        keyboard: {
          enabled: true,
        },
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous media',
          nextSlideMessage: 'Next media',
        },
      };

      if (enableNavigation) {
        mainOptions.navigation = {
          nextEl: '.media-gallery-main .swiper-button-next',
          prevEl: '.media-gallery-main .swiper-button-prev',
        };
      }

      mainSwiper = new Swiper('.media-gallery-main', mainOptions);
    }

    if (!mainSwiper || !thumbsSwiper) {
      initSwipers();
    }

    function handleResize() {
      var gridWrapper = document.getElementById('media-gallery-grid-wrapper');
      var swiperInline = document.getElementById('media-gallery-swiper-inline');
      if (window.innerWidth >= 990) {
        if (gridWrapper) gridWrapper.classList.remove('hidden');
        if (swiperInline) swiperInline.classList.add('hidden');
      } else {
        if (gridWrapper) gridWrapper.classList.add('hidden');
        if (swiperInline) swiperInline.classList.remove('hidden');
      }
      if (mainSwiper) {
        mainSwiper.params.centeredSlides = getCenteredSlides();
        mainSwiper.update();
      }
    }
    window.addEventListener('resize', handleResize);
    handleResize();
  });

  var showMoreBtn = document.getElementById('media-gallery-show-more');
  var grid = document.getElementById('media-gallery-grid');
  var fade = document.getElementById('media-gallery-fade');
  var collapsedMaxHeight = '900px';
  if (showMoreBtn && grid) {
    var expanded = false;
    showMoreBtn.addEventListener('click', function () {
      if (!expanded) {
        grid.style.maxHeight = 'none';
        showMoreBtn.textContent = 'Show Less';
        if (fade) fade.style.display = 'none';
        expanded = true;
      } else {
        grid.style.maxHeight = collapsedMaxHeight;
        showMoreBtn.textContent = 'Show More';
        if (fade) fade.style.display = '';
        expanded = false;
      }
    });
  }
})();
